
import React from "react"
import PropTypes from "prop-types"
import { Global } from "@emotion/core"
import { Helmet } from "react-helmet"
import { ThemeProvider, CSSReset } from "@chakra-ui/core"

import theme from "./theme"
import globalStyles from "./globalStyles"

const Layout = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <link href="https://fonts.googleapis.com/css?family=IBM+Plex+Mono|IBM+Plex+Sans:400,700|IBM+Plex+Serif:400,700&display=swap" rel="stylesheet" />
      </Helmet>
      <CSSReset />
      <Global styles={globalStyles} />
      <main>{children}</main>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
